import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // Scroll to top
        if (hash) {
            setTimeout(() => {
                const element = document.getElementById(hash.replace('#', ''));
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        } else {
            window.scrollTo(0, 0);
        }

        // Google Analytics Page View Tracking
        const gaId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;
        if (gaId && typeof window.gtag === 'function') {
            window.gtag('config', gaId, {
                page_path: pathname,
            });
        }

        // Meta Pixel Page View Tracking
        if (typeof window.fbq === 'function') {
            window.fbq('track', 'PageView');
        }
    }, [pathname, hash]);

    return null;
}
